import { QueryClient } from '@tanstack/react-query'
import { createRouter } from '@tanstack/react-router'
import { ErrorFallbackViewModel } from '@/components/shared/error-fallback/error-fallback.view-model'
import { NotFoundFloraViewModel } from '@/components/shared/not-found-flora/not-found-flora.view-model'
import { routeTree } from './routeTree.gen'

export function getRouter() {
  const queryClient = new QueryClient()

  return createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultErrorComponent: ErrorFallbackViewModel,
    defaultNotFoundComponent: NotFoundFloraViewModel,
  })
}
